export interface ScheduledGroup {
  startDate?: string | null;
  endDate?: string | null;
  schedules: { dayOfWeek: string; time: string }[];
}

export interface DayLesson<T> {
  time: string;
  group: T;
}

function ymd(value: string | null | undefined): string | null {
  if (!value) return null;
  return value.slice(0, 10);
}

/** Inclusive. A null end date means the group has not finished. */
export function groupCoversDate(
  startDate: string | null | undefined,
  endDate: string | null | undefined,
  date: string,
): boolean {
  const day = ymd(date);
  if (!day) return false;
  const start = ymd(startDate);
  const end = ymd(endDate);
  if (start && day < start) return false;
  if (end && day > end) return false;
  return true;
}

/**
 * Place each group's weekly slots only on calendar dates inside
 * [startDate, endDate]. Two levels of the same class can share a weekday
 * and a time; only the level that actually runs that day is shown.
 */
export function buildDayLessons<T extends ScheduledGroup>(
  groups: T[],
  datesByDay: Record<string, string>,
): Record<string, DayLesson<T>[]> {
  const map: Record<string, DayLesson<T>[]> = {};
  for (const day of Object.keys(datesByDay)) map[day] = [];

  for (const group of groups) {
    for (const slot of group.schedules) {
      const date = datesByDay[slot.dayOfWeek];
      if (!date || !groupCoversDate(group.startDate, group.endDate, date)) continue;
      (map[slot.dayOfWeek] ??= []).push({ time: slot.time, group });
    }
  }

  for (const day of Object.keys(map)) {
    map[day].sort((a, b) => a.time.localeCompare(b.time));
  }
  return map;
}
